import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { CalendarIcon, Check } from "lucide-react";
import { format } from "date-fns";

interface InlineDateEditProps {
  value: string;
  displayValue: string;
  onSave: (newDate: string) => Promise<void>;
  className?: string;
}

export function InlineDateEdit({ value, displayValue, onSave, className }: InlineDateEditProps) {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(value);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (date === value) { setOpen(false); return; }
    setSaving(true);
    try {
      await onSave(date);
      setOpen(false);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Popover open={open} onOpenChange={(o) => { setOpen(o); if (o) setDate(value); }}>
      <PopoverTrigger asChild>
        <button
          className={`inline-flex items-center gap-1 hover:text-primary hover:underline cursor-pointer text-left ${className || ""}`}
          onClick={(e) => e.stopPropagation()}
          title="Clic para cambiar fecha"
        >
          {displayValue}
          <CalendarIcon className="h-3 w-3 opacity-0 group-hover:opacity-50 transition-opacity" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-3" align="start" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-2">
          <Input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            className="h-8 text-sm w-[160px]"
          />
          <Button size="sm" className="h-8 px-2" onClick={handleSave} disabled={saving}>
            <Check className="h-4 w-4" />
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
